import { FC, React, useContext, useMemo, autoSet} from 'external/react'
import { InputField } from 'components/common/InputField'

import { ItemAccordion } from 'components/planning/plan-rd/components/ItemAccordion'

import {styled} from 'external/material'

import { Skills } from './Skills'
import { SkillName } from './Skills/SkillField'
import { TeacherContext } from 'teacher/context'

type UnitPlanProps = {

}
const skills: SkillName[] = [
  'communicative',
  'ethical',
  'logicalThinking',
  'problemSolving',
  'scientific',
  'environmental',
  'personalDevelopment'
]

const StyledUnitPlan = styled('div')(unitPlanStyles as any)

const UnitPlan: FC<UnitPlanProps> = () => {

    const {newPlan, translate, updateState} = useContext(TeacherContext) as any
    
    const unitPlan = useMemo(() => newPlan.content ? newPlan.content.unitPlan : undefined, [newPlan.content])

    function handleValueChange(key:string, value: string) {
      updateState({newPlan: autoSet(value, 'content', 'unitPlan', key)})
    }

  return (
    <StyledUnitPlan>
      <h5>{translate('planning-rd-unit-planning')}</h5>
      <InputField label={translate(`planning-rd-skill-cycle`)} value={unitPlan?.cycleSkill ?? ''} onChange={(value) => handleValueChange('cycleSkill', value)} />
      <InputField label={translate(`planning-rd-skill-grade`)} value={unitPlan?.gradeSkill ?? ''} onChange={(value) => handleValueChange('gradeSkill', value)} />
      {skills.map((skill) => (
        <ItemAccordion title={translate(`planning-rd-${skill}-label`)} key={skill} menuButton={false}>
          <Skills skill={skill}/>
        </ItemAccordion>
      ))}
    </StyledUnitPlan>
  )
}

function unitPlanStyles() {
  return {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '32px',
    marginTop: '32px',
    '& > h5': {
      fontWeight: 'bold',
      fontSize: '1.2rem',
      margin: 0
    }
  }
}

export {UnitPlan as default}